<script setup lang="ts">
import { computed } from 'vue';
import { every, isEmpty } from 'lodash';
import { useComponentComposable } from '@/components/useComponentComposable';
import Button from 'primevue/button';
import LongParagraphModal from '../modal/utils/LongParagraphModal.vue';

interface Props {
  value: any;
}
const props = defineProps<Props>();

const { renderHTMLContent } = useComponentComposable();
const topBannerInfo = computed(() => props.value);
const isEmptyDetail = computed(() => {
  return every(props.value, isEmpty);
});
</script>

<template>
  <div v-if="!isEmptyDetail" class="grid grid-nogutter surface-section text-800 mb-5 border-round">
    <div class="col-12 md:col-6 p-0 pr-3 md:text-left flex">
      <section>
        <renderHTMLContent :data="topBannerInfo?.name" htmlElement="h1"></renderHTMLContent>
        <renderHTMLContent class="mt-0 uppercase size-28 sub-title" :data="topBannerInfo?.subTitle" htmlElement="p"></renderHTMLContent>
        <LongParagraphModal :text="topBannerInfo?.description" class-component="my-4 text-700 line-height-3 word-break" />
        <Button :label="$t('promos.labels.learn_more_button')" type="button" class="mr-3 p-button-raised hidden"></Button>
        <Button :label="$t('promos.labels.live_demo_button')" type="button" class="p-button-outlined hidden"></Button>
      </section>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.max-width-500 {
  max-width: 500px;
}
.max-height-250 {
  max-height: 250px;
}
.word-break {
  word-break: break-word;
}
.size-28 {
  font-size: 2.8rem;
}
</style>
